import React from 'react';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import routes from '@src/constants/route';
import { StyledReferredOrdersHeader } from './index.style';

const ReferredOrdersHeader = () => {
  const { t } = useTranslation();
  return (
    <StyledReferredOrdersHeader>
      <CommonButton
        aria-label="close"
        variant="outlineSmall"
        customStyle={{
          width: '40px',
          height: '40px',
          minWidth: '40px',
        }}
        onClick={() => {
          if (window.history.length > 1 && document.referrer) {
            window.history.back();
          } else {
            window.location.replace(routes.REFERRAL);
          }
        }}
      >
        <ArrowBackRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      </CommonButton>
      <Typography variant="body-24-bold" color={COLOR.darkGray}>
        {t('paymentHistoryReferral')}
      </Typography>
    </StyledReferredOrdersHeader>
  );
};

export default ReferredOrdersHeader;
